// extracted by mini-css-extract-plugin
module.exports = {"form":"SignUp--form--1nwa-"};